import React, {useEffect, useState, Suspense} from "react"
import { EmojiEmotions } from '@mui/icons-material'
import styled from 'styled-components';
import { useComponentVisible } from "./hooks";
import COLOR from 'utils/constants/color';
import SentryWrap from "components/Sentry";

const Picker = React.lazy(() => import('@emoji-mart/react'));

const EmojiButton = styled.button`
    border: none;
    background-color: transparent;
    cursor: pointer;
`;
const EmojiWrapper = styled.div`
  position: absolute;
  bottom: ${p=>p.bottom?p.bottom:"60px"};
  overflow: visible;
  z-index: 1000;
  @media (max-width:996px){
    left:0;
  }
  @media (max-width: 1000px){
    position: fixed;
    left: auto;
    right: 8px;
    bottom: 128px;
    max-width: calc(100vw - 16px);
  }
`;
const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 5px;
`
export default function EmojiPicker({ onEmojiClick , bottom="60px", type=""}) {
    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = useComponentVisible(false);
    const isChat = type === "isChat"
    const [emojiData, setEmojiData] = useState(null);

    useEffect(() => {
        if (isComponentVisible && !emojiData) {
            import('@emoji-mart/data').then(module => {
                setEmojiData(module.default);
            });
        }
    }, [isComponentVisible, emojiData]);

    useEffect(() => {
        if (!isComponentVisible || !emojiData) return;
        const picker = document.querySelector("em-emoji-picker");
        const shadow = picker?.shadowRoot?.querySelector("section")?.querySelector('div[class*="scroll flex-grow padding-lr"]');
        if (shadow) {
          const style = document.createElement("style");
          style.textContent = `
            .scroll {
              overflow-x: auto !important;
            }
          `;
          shadow.appendChild(style);
        }
      }, [onEmojiClick, isComponentVisible, emojiData]);
    return (
        <SentryWrap>
            <Wrapper>
                {isComponentVisible && emojiData && (
                    <EmojiWrapper className="someSTyling" style={{ width: isChat && "213px", left: isChat && "-56px", overflow: 'scroll !important' }} ref={ref} bottom={bottom}>
                        <Suspense fallback={<div style={{ textAlign: 'center', padding: '20px' }}>Loading emoji picker...</div>}>
                            <Picker
                                data={emojiData}
                                onEmojiSelect={onEmojiClick}
                                theme="light"
                                previewPosition="none"
                                style={{ height: 300, width: '100%', maxWidth: 320, margin: '0 auto', overflow: 'scroll !important' }}
                            />
                        </Suspense>
                    </EmojiWrapper>
                )}
                <EmojiButton
                    onClick={() => setIsComponentVisible(true)}
                >
                    <EmojiEmotions style={{ color: COLOR.yellow }} />
                </EmojiButton>
            </Wrapper>
        </SentryWrap>);
}
